var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("path", {
    attrs: {
      "fill-rule": "evenodd",
      d:
        "M74.864 1.444C66.12 1.227 25.087-4.128 12.22 9.37-.61 22.826-3.748 50.184 7.922 60.667 19.592 71.15 57.92 68.7 68.21 68.955c6.72.167 43.363-1.366 56.434-11.219 9.18-6.92 11.848-21.03 4.523-36.42C121.75 2.395 80.781 1.59 74.864 1.443z"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-92a0972e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92a0972e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/_SVG/ShapeYearBtn4Mob.vue
// module id = wJl+
// module chunks = 1